
/** replace ligatures such as ﬁ with regular characters */
export function cleanLigatures(s: string): string {
  allLigatures.forEach(l => s = s.replace(new RegExp(l, 'g'), ligatureToChar[l]));
  return s;
}

const ligatureToChar: Record<string, string> = {
  "ꜳ": "aa",
  "ꜵ": "ao",
  "ꜷ": "au",
  "ꜹ": "av",
  "ꜻ": "av",
  "ꜽ": "ay",
  "ﬀ": "ff",
  "ﬃ": "ffi",
  "ﬄ": "ffl",
  "ﬁ": "fi",
  "ﬂ": "fl",
  "ƕ": "hv",
  "℔": "lb",
  "ỻ": "ll",
  "ꝏ": "oo",
  "ꭢ": "ɔe",
  "ﬆ": "st",
  "ﬅ": "ſt",
  "ꜩ": "tz",
  "ᵫ": "ue",
  "ꭣ": "uo",
  "ꝡ": "vy",
  "ꟗ": "ſs",
  "ꟕ": "ƿƿ",
  "ꟓ": "þþ",
}
const allLigatures = Object.getOwnPropertyNames(ligatureToChar);
